import { StyledGraph } from './Graph.style';
import useGraph from './useGraph';
import HighChart from 'components/highcharts/HighChart';
import EmptyStateAdjustFilters from '../../empty-state/EmptyStateAdjustFilters';

const Graph = ({ data, granularity, type, tooltipsData }) => {
  const { graphOptions, isZeroProgression } = useGraph({
    data,
    granularity,
    type,
    tooltipsData
  });

  const isEmptyState = data?.length === 0 || isZeroProgression;
  if (isEmptyState) return <EmptyStateAdjustFilters />;

  return (
    <StyledGraph>
      <HighChart
        containerProps={{ style: { height: '100%', width: '100%' } }}
        options={graphOptions}
      />
    </StyledGraph>
  );
};

export default Graph;
